import type { FetchService, ServiceName } from 'runtimes-shared'
import insightsBaseUrl from './insights/baseUrl'
import { getResourceBytes } from './resource/client'
import fetchAuthorized from './authorization/fetchAuthorized'

type ServiceConfig = { baseUrl: string; authenticated: boolean }

const services: Record<Exclude<ServiceName, 'resources'>, ServiceConfig> = {
  insights: { baseUrl: insightsBaseUrl, authenticated: true },
}

const gzipBody = async (init?: RequestInit): Promise<RequestInit | undefined> => {
  if (!init?.body) return init
  const request = new Request('', { method: 'POST', body: init.body })
  const blob = await request.blob()
  const compressed = await new Response(blob.stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer()
  return {
    ...init,
    body: compressed,
    headers: { ...init.headers, 'Content-Encoding': 'gzip' },
  }
}

const fetchResource = async (path: string): Promise<Response> => {
  const bytes = await getResourceBytes(path.replace(/^\//, ''))
  return bytes ? new Response(new Uint8Array(bytes)) : new Response(null, { status: 404 })
}

const fetchService: FetchService = async (service, path, init) => {
  if (service === 'resources') return fetchResource(path)

  const { baseUrl, authenticated } = services[service]
  const url = `${baseUrl}${path}`
  if (!authenticated) return fetch(url, init)

  return fetchAuthorized(url, await gzipBody(init))
}

export default fetchService
